import { render } from "./ConfirmSendCorreoModal.vue?vue&type=template&id=cbcabd32"
import script from "./ConfirmSendCorreoModal.vue?vue&type=script&lang=js"
export * from "./ConfirmSendCorreoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__